import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { ControlContainer, Validators } from '@angular/forms';
import { Util } from '../../utils/util';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'contato',
    templateUrl: './contato.component.html',
    styleUrls: ['./contato.component.scss']
})
export class ContatoFormComponent {

    @Input() showHeader = false;
    MSG_CAMPO_OBRIGATORIO = Util.getMensagemCampoObrigatorio();
    MSG_CAMPO_INVALIDO = Util.getMensagemCampoInvalido();

    @ViewChild('emailAlternativo', { static: false })
    private emailAlternativo: ElementRef<any>;

    constructor(public controlContainer: ControlContainer) { }

    limparContato() {
        this.controlContainer.reset();
    }

    /**
     * Valida dinamicamente se deve validar o email alternativo.
     */
    public insertEmailValidators() {
        if (this.controlContainer.control.get('EmailAlternativo').value && this.controlContainer.control.get('EmailAlternativo').value !== '') {
            this.controlContainer.control.get('EmailAlternativo').setValidators(Validators.email);
            this.emailAlternativo.nativeElement.classList.add('validation-field');
        } else {
            this.controlContainer.control.get('EmailAlternativo').clearValidators();
            this.emailAlternativo.nativeElement.classList.remove('validation-field');
        }
        this.controlContainer.control.get('EmailAlternativo').updateValueAndValidity();
    }
}
